/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from "react"
import { Radio, RadioProps as MantineRadioProps } from "@mantine/core"
import { RadioProps as MUIRadioProps } from "@mui/material"
import withMappedProps from "hoc-lib/propsMapping"

import styles from "./Radio.mantine.module.scss"

export const MantineRadio = Radio

export default MantineRadio

const muiToMantine = (props: MUIRadioProps): MantineRadioProps => {
  const anyProps = props as any
  return {
    ...anyProps,
    icon: undefined,
    value: anyProps.value,
    variant: "outline",
    classNames: styles,
    color: "var(--gaia-color-brand-green-600)",
  }
}

export const MUIMappedRadio = withMappedProps(MantineRadio, muiToMantine)
